<script setup lang="ts">
import Select from 'primevue/select';
import { PLATFORM_COUNTRIES, PLATFORM_COUNTRY_OPTIONS, platformCountryFlagClass, type PlatformCountry } from '@/platformCountry';

// Form-field picker for an account's platform country (flag + name). Used in system admin screens.
// null = not set; the placeholder shows until one is picked.
defineProps<{ modelValue: PlatformCountry | null; disabled?: boolean; placeholder?: string }>();
const emit = defineEmits<{ (e: 'update:modelValue', value: PlatformCountry): void }>();
</script>

<template>
    <Select
        :model-value="modelValue"
        :options="PLATFORM_COUNTRY_OPTIONS"
        option-label="label"
        option-value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        @update:model-value="emit('update:modelValue', $event)"
    >
        <template #value="{ value, placeholder: placeholderText }">
            <span v-if="value" class="flex items-center gap-2">
                <span :class="platformCountryFlagClass(value)" class="shrink-0 rounded-sm" />
                {{ PLATFORM_COUNTRIES[value as PlatformCountry].name }}
            </span>
            <span v-else class="text-surface-400">{{ placeholderText }}</span>
        </template>
        <template #option="{ option }">
            <span class="flex items-center gap-2">
                <span :class="option.flagClass" class="shrink-0 rounded-sm" />
                {{ option.label }}
            </span>
        </template>
    </Select>
</template>
